import React from "react";
import { getAuthUser } from "../utils/cookieUtils";
import { useTranslation } from "../hooks/useTranslation";

type CreateStoryButtonProps = {
  onClick: () => void;
};

const CreateStoryButton: React.FC<CreateStoryButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const user = getAuthUser();

  if (!user) return null;

  return (
    <div className="flex flex-col items-center space-y-2 flex-shrink-0">
      <div
        className="relative bg-gradient-to-tr from-gray-300 to-gray-400 dark:from-gray-600 dark:to-gray-700 rounded-full p-[3px]
        cursor-pointer hover:scale-105 transition-transform duration-200 ease-out"
        onClick={onClick}
      >
        <div className="bg-white dark:bg-gray-800 rounded-full p-[3px]">
          <img
            className="h-14 w-14 rounded-full object-cover"
            src={user.image}
            alt="Your profile"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = '/default-avatar.svg';
            }}
          />
          {/* Plus icon overlay */}
          <div className="absolute bottom-0 right-0 bg-blue-500 rounded-full w-6 h-6 flex items-center justify-center border-2 border-white dark:border-gray-800 shadow-lg">
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          </div>
        </div>
      </div>
      <p className="text-xs w-14 truncate text-center text-gray-900 dark:text-gray-100 leading-tight">{t('story.createLabel')}</p>
    </div>
  );
};

export default CreateStoryButton;